module.exports = __webpack_public_path__ + "img/21.68cbb9ad.jpg";